<template>
  <section class="closefriend-hero " style="height: 100vh; overflow: hidden;">
    <div class="container-fluid h-100 p-0">
      <div class="row h-100 g-0">
        
        <!-- ======================== -->
        <!-- LEFT PANEL: Filter List  -->
        <!-- ======================== -->
        <div class="col-12 col-md-4 col-lg-3 h-100 flex-column chat-sidebar-panel"
             :class="(selectedFilter && selectedFilter.id) ? 'd-none d-md-flex' : 'd-flex'">
             
          <!-- Header -->
          <div class="p-3 border-bottom border-white-10 chat-sidebar-header">
            <div class="d-flex align-items-center mb-3">
              <span class="cursor-pointer text-white me-3" @click="$router.push({ name: 'CreatorMessageDashboard', query: { tab: 'groups' } })">
                <i class="fa fa-arrow-left"></i>
              </span>
              <h5 class="text-white font-weight-500 mb-0">Announcements</h5>
            </div>
            
            <div class="d-flex justify-content-between align-items-center mt-3">
              <h6 class="text-white mb-0 font-size-14" style="opacity: 0.7;">Broadcast Groups</h6>
              <span class="cursor-pointer" @click="$refs.filterGroup.show(filterSettings)">
                <i class="fa fa-pencil-square-o hover-pink"></i>
              </span>
            </div>
          </div>

          <!-- Group List -->
          <div class="flex-grow-1 overflow-auto" id="sidebar-content">
            <div v-if="isFiltersLoading && filterSettings.length === 0" class="py-4">
              <div v-for="i in 4" :key="i" class="msg-inbox-row m-2 d-flex align-items-center mb-2" style="border-color: rgba(255,255,255,0.05); cursor: default;">
                <div class="me-3 flex-shrink-0" style="width: 40px; height: 40px; border-radius: 50%; background: rgba(255,255,255,0.05); animation: pulse 1.5s infinite;"></div>
                <div class="flex-grow-1">
                  <div style="height: 14px; background: rgba(255,255,255,0.08); width: 40%; border-radius: 4px; margin-bottom: 8px; animation: pulse 1.5s infinite;"></div>
                  <div style="height: 12px; background: rgba(255,255,255,0.04); width: 65%; border-radius: 4px; animation: pulse 1.5s infinite;"></div>
                </div>
              </div>
            </div>
            <div v-else v-for="(filter, index) in filterSettings" :key="index"
                 class="msg-inbox-row m-2 cursor-pointer"
                 :class="(selectedFilter && selectedFilter.id === filter.id) ? 'active' : ''"
                 @click="changeFilter(filter)">
                 <div class="d-flex align-items-center" style="min-width: 0;">
                    <div class="msg-filter-icon me-3 flex-shrink-0" style="width: 40px; height: 40px; border-radius: 50%; display: flex; align-items: center; justify-content: center; background: rgba(255,255,255,0.05); border: 1px solid rgba(255,255,255,0.1);">
                      <i class="fa fa-users" style="color: #F3DA6B;"></i>
                    </div>
                    <div class="flex-grow-1" style="min-width: 0;">
                      <div class="d-flex align-items-center justify-content-between">
                        <span class="text-white font-size-14 font-weight-500 text-truncate" :title="filter.name">{{ filter.name }}</span>
                      </div>
                      <div class="d-flex align-items-center mt-1">
                        <p class="text-muted font-size-12 mb-0 text-truncate flex-grow-1" :title="`${filter.customerCount} Subscribers`">
                          {{ filter.customerCount }} Subscribers
                        </p>
                      </div>
                      <div class="d-flex align-items-center mt-1" v-if="filter.latestChat">
                        <p class="text-muted font-size-12 mb-0 text-truncate flex-grow-1" :title="`You: ${filter.latestChat.message}`">
                          You: {{ cropMessage(filter.latestChat) }}
                        </p>
                      </div>
                    </div>
                 </div>
            </div>
          </div>
        </div>

        <!-- ======================== -->
        <!-- RIGHT PANEL: Chat Area   -->
        <!-- ======================== -->
        <div class="col-12 col-md-8 col-lg-9 h-100 flex-column chat-main-panel"
             :class="(selectedFilter && selectedFilter.id) ? 'd-flex' : 'd-none d-md-flex'">
          
          <template v-if="selectedFilter && selectedFilter.id">
            <!-- Chat Header -->
            <div class="p-3 border-bottom border-white-10 d-flex align-items-center justify-content-between chat-header-bar z-index-1">
              <div class="d-flex align-items-center">
                <span class="cursor-pointer text-white me-3 d-md-none" @click="$router.push({ name: 'CreatorMessageDashboard', query: { tab: 'groups' } })">
                  <i class="fa fa-arrow-left"></i>
                </span>
                <div class="msg-filter-icon me-3 flex-shrink-0" style="width: 40px; height: 40px; border-radius: 50%; display: flex; align-items: center; justify-content: center; background: rgba(255,255,255,0.05); border: 1px solid rgba(255,255,255,0.1);">
                  <i class="fa fa-users" style="color: #F3DA6B;"></i>
                </div>
                <div>
                  <h6 class="text-white font-weight-500 mb-0">{{ selectedFilter.name || 'Announcement Group' }}</h6>
                  <p class="text-muted font-size-12 mb-0" v-if="selectedFilter.customerCount !== undefined">{{ selectedFilter.customerCount }} Subscribers</p>
                </div>
              </div>
            </div>

            <!-- Chat Messages Area -->
            <div class="flex-grow-1 overflow-auto p-3 p-md-4 position-relative" id="content">
              <!-- Thread Loading Spinner -->
              <div v-if="isMessagesLoading && filterMessages.length === 0" class="h-100 d-flex flex-column align-items-center justify-content-center">
                <div class="stella-pulse-spinner mb-3">
                  <div class="stella-pulse-dot"></div>
                  <div class="stella-pulse-dot"></div>
                  <div class="stella-pulse-dot"></div>
                </div>
                <span class="text-white font-size-13" style="opacity: 0.5;">Loading announcements...</span>
              </div>
              <template v-else>
                <div class="d-flex flex-column align-items-end mb-3" :id="`message_${index}`"
                     v-for="(message, index) in filterMessages" :key="index">
                  <div class="chat-bubble-creator">
                    <span v-if="message.message" v-html="formatMessage(message.message)"></span>
                    
                    <template v-if="message.content">
                      <div class="mt-2 text-center w-100">
                        <img v-if="message.content.type === 'IMAGE'" @click="showMediaPreview($event, message.content)"
                             @load="handleMediaLoad"
                             :src="message.content.cdnUrl" alt="" class="chat-media-attachment cursor-pointer">
                        <video v-else-if="message.content.type === 'VIDEO'" @click="showMediaPreview($event, message.content)"
                               @loadeddata="handleMediaLoad"
                               oncontextmenu="return false;" controlsList="nodownload" controls :src="message.content.cdnUrl"
                               class="chat-media-attachment cursor-pointer">
                        </video>
                      </div>
                    </template>
                  </div>
                </div>
              </template>
            </div>

            <!-- Chat Input Area -->
            <div class="p-3 border-top border-white-10 chat-input-bar z-index-1">
              <div class="d-flex align-items-end bg-dark-glass p-2 chat-input-container" style="border-radius: 24px;">
                <span class="cursor-pointer text-muted px-3 py-2" @click="$refs.uploadFile.show(null, selectedFilter.id)">
                  <i class="fa fa-paperclip font-size-18 hover-pink"></i>
                </span>
                
                <div class="flex-grow-1 text-white chat-input-editable mx-2 py-2" contenteditable="true"
                     @input="updateMessage" @keydown.enter="handleEnterKey" @paste="handlePaste"
                     placeholder="Type your announcement..."></div>
                
                <span class="cursor-pointer px-3 py-2" @click="sendMessage()">
                  <i class="fa fa-paper-plane font-size-18 pwa-gradient-icon"></i>
                </span>
              </div>
            </div>
          </template>
          
          <!-- Empty State -->
          <div v-else class="h-100 d-flex flex-column align-items-center justify-content-center">
             <div class="stella-empty-state-icon mb-3">
               <i class="fa fa-bullhorn font-size-32" style="opacity: 0.4; color: #E53BB9;"></i>
             </div>
             <h5 class="text-white font-weight-500 mb-2" style="opacity: 0.6;">Announcements</h5>
             <p class="text-white font-size-14 mb-0" style="opacity: 0.35;">Select a broadcast group to view or send messages</p>
          </div>
          
        </div>

      </div>
    </div>
    
    <filter-group ref="filterGroup"
                  :filter-settings="filterSettings"
                  @create="$refs.filterModal.show(null)"
                  @edit="(filter) => {
                    changeFilter(filter);
                    $refs.filterGroup.hide();
                  }"/>
    <filter-modal ref="filterModal" @saved="createdFilter"/>

    <upload-media ref="uploadFile"
                  message-type="filterMessage"
                  @messageSent="contentMessageSent"/>

    <model-image-view ref="imageView"/>
    <model-video-view ref="videoView"/>
    
  </section>
</template>

<script>
import '@/assets/styles/direct-message/direct-message-common.css';
import FilterGroup from "@/components/module/influencer/direct-message/FilterGroup";
import FilterModal from "@/components/module/influencer/direct-message/FilterModal";
import {SERVICE_DIRECT_MESSAGE} from "@/properties/micro-service";
import {mapGetters, mapActions} from "vuex";
import {httpMixin} from "@/mixin/http-mixin";
import UploadMedia from "@/components/module/influencer/direct-message/UploadMedia";
import {CONTENT_TYPE_IMAGE, CONTENT_TYPE_VIDEO} from "@/properties/content-type";
import ModelImageView from "@/components/module/shared/ModelImageView";
import ModelVideoView from "@/components/module/shared/ModelVideoView";
import {cropMessage, scroll} from "@/common/Utils";
import GlobalMessage from "@/components/module/shared/GlobalMessage";

export default {
  name: 'Announcement',
  mixins: [httpMixin],
  components: {
    ModelVideoView,
    ModelImageView,
    UploadMedia,
    FilterGroup, 
    FilterModal,
    GlobalMessage
  },
  data() {
    let initialFilter = {};
    const stored = localStorage.getItem('selectedAnnocmcementId');
    if (stored) {
      initialFilter = { id: parseInt(stored) };
    }
    return {
      filterSettings: [],
      selectedFilter: initialFilter,
      filterMessages: [],
      activeFilters: [],
      message: null,
      isFiltersLoading: false,
      isMessagesLoading: false,
    }
  },
  created() {
    if (this.selectedFilter && this.selectedFilter.id) {
      this.getFilterMessages();
    }
    this.getFilters();
  },
  computed: {
    ...mapGetters(['getUser']),
  },
  watch: {
    getUser: {
      handler(user) {
        if (user && user.id && (!this.filterSettings || this.filterSettings.length === 0)) {
          this.getFilters();
        }
      }
    }
  },
  destroyed() {
    localStorage.removeItem('selectedAnnocmcementId');
  },
  methods: {
    ...mapActions(['pushGlobalError']),
    getFilters(disableLoading = true) {
      if (!this.getUser || !this.getUser.id) return;
      this.isFiltersLoading = true;
      let url = `${SERVICE_DIRECT_MESSAGE}/api/v1/chat/filter-settings/influencers/${this.getUser.id}`;
      this.getData(url, (filterSettings) => {
        this.isFiltersLoading = false;
        this.filterSettings = filterSettings || [];
        if (this.filterSettings.length > 0) {
          const storedFilterId = localStorage.getItem('selectedAnnocmcementId');
          let selectedFilterIndex = 0;

          if (storedFilterId) {
            selectedFilterIndex = this.filterSettings.findIndex(filter => filter && filter.id === parseInt(storedFilterId));
            selectedFilterIndex = selectedFilterIndex === -1 ? 0 : selectedFilterIndex;
          }

          this.selectedFilter = this.filterSettings[selectedFilterIndex] || {};
          this.getFilterMessages();
          this.getLatestFilterMessage();
        }
        if (this.$route.query.newFilter) {
          this.$nextTick(() => {
            if (this.$refs.filterGroup && typeof this.$refs.filterGroup.show === 'function') {
              this.$refs.filterGroup.show();
            }
          });
        }
      }, (err) => {
        this.isFiltersLoading = false;
      }, disableLoading);
    },
    getFilterMessages() {
      if (!this.selectedFilter || !this.selectedFilter.id) return;
      if (!this.getUser || !this.getUser.id) return;
      let infId = this.getUser.id;
      let filterId = this.selectedFilter.id;
      let url = `${SERVICE_DIRECT_MESSAGE}/api/v1/chat/filter-messages/influencers/${infId}/filter/${filterId}`;
      if (this.filterMessages.length === 0) {
        this.isMessagesLoading = true;
      }
      this.getData(url, (messages) => {
        this.isMessagesLoading = false;
        this.filterMessages = messages || [];
        this.scrollToMessage(this.filterMessages.length - 1);
      }, (err) => {
        this.isMessagesLoading = false;
      }, true);
    },
    getLatestFilterMessage() {
      if (!this.getUser || !this.getUser.id) return;
      let infId = this.getUser.id;
      let url = `${SERVICE_DIRECT_MESSAGE}/api/v1/chat/filter-messages/influencers/${infId}/latest`;
      this.getData(url, (latestMessages) => {
        if (!latestMessages || !Array.isArray(latestMessages)) return;
        latestMessages.forEach((lm) => {
          if (!lm) return;
          const filterId = (lm.chatFilterSetting && lm.chatFilterSetting.id) || lm.chatFilterSettingId || lm.filterSettingId || lm.filterId;
          if (!filterId) return;
          let fs = this.filterSettings.find((fs) => fs && fs.id === filterId);
          if (fs) {
            if (this.$set) {
              this.$set(fs, 'latestChat', lm);
            } else {
              fs.latestChat = lm;
            }
          }
        });
        this.activeFilters = [];
        this.filterSettings.forEach((fm) => {
          if (fm && fm.latestChat) {
            this.activeFilters.push(fm);
          }
        });
      }, (err) => {}, true);
    },
    changeFilter(filter) {
      if (!filter) return;
      this.selectedFilter = filter;
      this.filterMessages = [];
      if (filter && filter.id) {
        localStorage.setItem('selectedAnnocmcementId', filter.id);
      }
      this.getFilterMessages();
    },
    createdFilter(filter) {
      if (!filter) return;
      this.filterSettings.push(filter);
      this.selectedFilter = filter;
    },
    contentMessageSent(message) {
      this.filterMessages.push(message);
      this.scrollToMessage(this.filterMessages.length - 1);
    },
    handleMediaLoad() {
      this.scrollToMessage(this.filterMessages.length - 1);
    },
    scrollToMessage(num) {
      if (num === -1) {
        return;
      }
      this.$nextTick(() => {
        this.scroll(`message_${num}`);
      });
    },
    scroll,
    sendMessage() {
      if (!this.message) return;
      this.message = this.message.replace(/\n/g, '<br>');
      this.message = this.message.trim();

      this.message = this.message.replace(/^&nbsp;+/g, '');
      this.message = this.message.replace(/&nbsp;+$/g, '');
      this.message = this.message.replace(/&nbsp;/g, '');
      this.message = this.message.trim();

      while (this.message.startsWith('<br>')) {
        this.message = this.message.slice(4);
      }
      while (this.message.endsWith('<br>')) {
        this.message = this.message.slice(0, -4);
      }
      this.message = this.message.trim();
      if (!this.message || !this.message.trim()) return;
      if (!this.getUser || !this.getUser.id || !this.selectedFilter || !this.selectedFilter.id) return;
      
      let filterMessage = {
        "message": this.message,
        "contentId": null,
      }
      let infId = this.getUser.id;
      let filterId = this.selectedFilter.id;
      let url = `${SERVICE_DIRECT_MESSAGE}/api/v1/chat/filter-messages/influencers/${infId}/filter/${filterId}`;
      this.postData(url, filterMessage, (message) => {
        this.filterMessages.push(message);
        this.message = null;
        const div = this.$el.querySelector('.chat-input-editable');
        if(div){
          div.innerHTML='';
        }
        this.scrollToMessage(this.filterMessages.length - 1);
      }, (errorResponse) => {
        let errorMsg = "Failed to send message.";
        if (errorResponse && errorResponse.globalErrors && errorResponse.globalErrors.length > 0) {
          errorMsg = errorResponse.globalErrors[0].code || errorResponse.globalErrors[0].message;
        } else if (errorResponse && errorResponse.allErrors && errorResponse.allErrors.length > 0) {
          errorMsg = errorResponse.allErrors[0].code || errorResponse.allErrors[0].message;
        }
        this.pushGlobalError(errorMsg);
      })
    },
    showMediaPreview(event, content) {
      if (!this.isMobile()) {
        event.preventDefault();
      }
      if (content.type === CONTENT_TYPE_IMAGE && content.cdnUrl) {
        this.$refs.imageView.show(content.cdnUrl);
      } else if (content.type === CONTENT_TYPE_VIDEO && content.cdnUrl) {
        this.$refs.videoView.show(content.cdnUrl);
      }
    },
    handleEnterKey(event) {
      if (event.shiftKey) {
        return;
      } else {
        event.preventDefault();
        this.sendMessage();
      }
    },
    updateMessage(event) {
      const div = event.target;
      if (div) {
        const text = div.innerText ? div.innerText.replace(/\r\n/g, '\n') : '';
        this.message = text === '\n' ? '' : text;
      }
    },
    handlePaste(event) {
      event.preventDefault();
      const text = (event.clipboardData || window.clipboardData).getData('text/plain');
      document.execCommand('insertText', false, text);
    },
    formatMessage(message) {
      if (message) {
        const urlPattern = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])|(\b(www\.[\S]+))/gi;
        return message.replace(urlPattern, url => {
          const href = url.startsWith('www.') ? `http://${url}` : url;
          return `<a href="${href}" target="_blank" rel="noopener noreferrer">${url}</a>`;
        });
      } else {
        return 'N/A'
      }
    },
    cropMessage,
  }
}
</script>

<style scoped>
/* --- CLEAN UI STYLES --- */
.bg-dark-transparent {
    background: rgba(17, 17, 17, 0.95);
}

.bg-dark-glass {
    background: rgba(255, 255, 255, 0.05);
}

.border-white-10 {
    border-color: rgba(255, 255, 255, 0.1) !important;
}

.msg-inbox-row {
    padding: 12px;
    border-radius: 12px;
    transition: all 0.2s ease;
    background: transparent;
}

.msg-inbox-row:hover {
    background: rgba(255, 255, 255, 0.05);
}

.msg-inbox-row.active {
    background: rgba(255, 255, 255, 0.08);
    box-shadow: inset 3px 0 0 #E53BB9;
}

.chat-bubble-creator {
    background: linear-gradient(135deg, #F3DA6B 0%, #E53BB9 100%);
    color: white;
    padding: 12px 16px;
    border-radius: 16px 16px 4px 16px;
    max-width: 75%;
    font-size: 14px;
    line-height: 1.5;
    word-break: break-word;
}

.chat-media-attachment {
    width: 220px;
    height: 220px;
    object-fit: cover;
    border-radius: 12px;
}

.chat-input-editable {
    min-height: 24px;
    max-height: 120px;
    overflow-y: auto;
    outline: none;
    line-height: 1.5;
    word-break: break-word;
    font-size: 14px;
}

.chat-input-editable:empty:before {
    content: attr(placeholder);
    color: rgba(255, 255, 255, 0.4);
    pointer-events: none;
}

.hover-pink {
    transition: color 0.2s ease;
}

.hover-pink:hover {
    color: #E53BB9 !important;
}

.stella-empty-state-icon {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    background: rgba(229, 59, 185, 0.1);
    display: flex;
    align-items: center;
    justify-content: center;
}

.z-index-1 {
    z-index: 1;
}
</style>
